import { TextFieldProps, debounce, TextField } from '@mui/material'
import { useMemo, useState, useCallback, useEffect } from 'react'

type InputDebouncedProps = Omit<TextFieldProps, 'value' | 'onChange'> & {
  value: string
  onChange: (value: string) => void
  debounceTime?: number
}

export default function InputDebounced(props: InputDebouncedProps) {
  const { value, onChange, debounceTime = 750, ...textFieldProps } = props
  const [inputValue, setInputValue] = useState(value)
  const [debouncedInputValue, setDebouncedInputValue] = useState(value)
  const debounceInputValue = useMemo(() => debounce((text: string) => setDebouncedInputValue(text), debounceTime), [])
  const onInputChange: React.ChangeEventHandler<HTMLInputElement> = useCallback((event) => {
    setInputValue(event.target.value)
    debounceInputValue(event.target.value)
  }, [])

  useEffect(() => {
    if (value !== debouncedInputValue) {
      onChange(debouncedInputValue)
    }
  }, [debouncedInputValue])

  return <TextField {...textFieldProps} value={inputValue} onChange={onInputChange} />
}
